import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ErrorBoundary from './components/ui/ErrorBoundary';
import ScrollToTop from './components/ui/ScrollToTop';

const Home = lazy(() => import('./pages/Home'));
const Products = lazy(() => import('./pages/Products'));
const SmartContracts = lazy(() => import('./pages/SmartContracts'));
const Contact = lazy(() => import('./pages/Contact'));
const Blog = lazy(() => import('./pages/Blog'));
const Pricing = lazy(() => import('./pages/Pricing'));
const Troubleshoot = lazy(() => import('./pages/Troubleshoot'));
const Verify = lazy(() => import('./pages/Verify'));
const TechCertPage = lazy(() => import('./pages/TechCertPage'));
const NotFound = lazy(() => import('./pages/NotFound'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const CookiePolicy = lazy(() => import('./pages/CookiePolicy'));
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions'));
// const PurchaseAccess = lazy(() => import('./pages/PurchaseAccess'));
const Checkout = lazy(() => import('./pages/Checkout'));

function MainLayout() {
  return (
    <>
      <Navbar />
      <Suspense fallback={<div className="page-loading" />}>
        <Outlet />
      </Suspense>
      <Footer />
    </>
  );
}

function BareLayout() {
  return (
    <Suspense fallback={<div className="page-loading" />}>
      <Outlet />
    </Suspense>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<BareLayout />}>
            <Route path="/tech-cert" element={<TechCertPage />} />
          </Route>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/certificates" element={<SmartContracts />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blogs" element={<Blog />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/troubleshoot" element={<Troubleshoot />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            {/* <Route path="/purchase" element={<PurchaseAccess />} /> */}
            <Route path="/checkout" element={<Checkout />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
